export const commandMap = {
  'help': [
    '╔════════════════════════════════════════════════════════════╗',
    '║          AVAILABLE COMMANDS - DEEZSEC TERMINAL             ║',
    '╚════════════════════════════════════════════════════════════╝',
    '',
    '🚀 projects   : Launch interactive project showcase',
    '🔬 skills     : Display technical capabilities',
    '🌐 contact    : Establish secure connection',
    '💻 neofetch   : Display system information',
    '🔗 socials    : View social media profiles',
    '💡 whoami     : Discover who DeezSec is',
    '🎭 matrix     : Toggle Matrix rain effect',
    '🔒 clear      : Reset the terminal display',
    '',
    '💡 Tip: Click icons in the dock below for quick access!',
    ''
  ],
  'projects': [
    '╔════════════════════════════════════════════════════════════╗',
    '║                    PROJECT SHOWCASE                        ║',
    '╚════════════════════════════════════════════════════════════╝',
    '',
    '📡 [1] Wireless Penetration Testing Framework',
    '   └─ Tools: Airgeddon, WiFi Auditing, WPA/WPA2 Analysis',
    '   └─ Impact: Identified 15+ network vulnerabilities',
    '',
    '👁️  [2] OSINT Intelligence Platform',
    '   └─ Tools: Custom scrapers, Data correlation, OSINT Framework',
    '   └─ Impact: Successful reconnaissance on 50+ targets',
    '',
    '🤖 [3] Exploit Development Suite',
    '   └─ Tools: Bash/Python scripting, Metasploit integration',
    '   └─ Impact: Automated exploitation workflows',
    '',
    '🔐 [4] Network Forensics Lab',
    '   └─ Tools: Wireshark, tcpdump, Network analysis',
    '   └─ Impact: Analyzed 100+ network incidents',
    '',
    '⚡ [5] Threat Hunting Dashboard',
    '   └─ Tools: ELK Stack, Sigma rules, Threat intelligence',
    '   └─ Impact: Reduced detection time by 60%',
    '',
    '💡 Type "projects" again to toggle interactive 3D cards!',
    ''
  ],
  'skills': [
    '╔════════════════════════════════════════════════════════════╗',
    '║              TECHNICAL SKILL MATRIX                        ║',
    '╚════════════════════════════════════════════════════════════╝',
    '',
    '🛡️  PENETRATION TESTING',
    '   ├─ Vulnerability Assessment & Exploitation',
    '   ├─ Web Application Security (OWASP Top 10)',
    '   └─ Wireless Network Auditing',
    '',
    '🔍 DIGITAL FORENSICS',
    '   ├─ Network Forensics & Packet Analysis',
    '   ├─ Memory Forensics & Malware Analysis',
    '   └─ Incident Response & Threat Hunting',
    '',
    '💻 SCRIPTING & AUTOMATION',
    '   ├─ Bash Scripting & Shell Automation',
    '   ├─ Python for Security Tools',
    '   └─ Privilege Escalation Techniques',
    '',
    '🧠 AI/ML SECURITY',
    '   ├─ Prompt Injection in Large Language Models',
    '   ├─ AI Red Teaming',
    '   └─ Adversarial Machine Learning',
    '',
    '🐧 SYSTEM ADMINISTRATION',
    '   ├─ Linux System Administration (Arch, Debian, RHEL)',
    '   ├─ Network Configuration & Hardening',
    '   └─ Security Configuration & Compliance',
    '',
    '🔐 CRYPTOGRAPHY',
    '   ├─ PGP/GPG Encryption',
    '   ├─ SSL/TLS Analysis',
    '   └─ Cryptographic Protocol Analysis',
    ''
  ],
  'contact': [
    '╔════════════════════════════════════════════════════════════╗',
    '║              SECURE CONTACT CHANNELS                       ║',
    '╚════════════════════════════════════════════════════════════╝',
    '',
    '📧 Email (Encrypted)',
    '   └─ d4dz@tuta.io',
    '   └─ PGP Key: [Available on request]',
    '',
    '🔒 Secure Messaging',
    '   └─ Signal: Available upon request',
    '   └─ Session: End-to-end encrypted',
    '',
    '🌐 Professional Networks',
    '   └─ LinkedIn: /in/deezsec',
    '   └─ GitHub: /deezsec',
    '',
    '⚠️  Security Notice:',
    '   All communications are monitored for security.',
    '   Please use encryption for sensitive information.',
    ''
  ],
  'whoami': [
    '╔════════════════════════════════════════════════════════════╗',
    '║                      DEEZSEC.PROFILE                       ║',
    '╚════════════════════════════════════════════════════════════╝',
    '',
    '👤 Identity: DeezSec',
    '🎯 Mission: Securing the digital frontier, one vulnerability at a time',
    '💡 Vision: Building robust security postures through offensive security',
    '',
    '🏆 Specialties:',
    '   ├─ Penetration Testing & Red Teaming',
    '   ├─ Network Forensics & Threat Analysis',
    '   ├─ Security Automation & Tool Development',
    '   └─ AI/ML Security Research',
    '',
    '🌟 Philosophy:',
    '   "Fall seven times, stand up eight."',
    '   - Continuous learning and improvement in cybersecurity',
    '',
    '🎓 Certifications & Training:',
    '   ├─ Self-taught security researcher',
    '   ├─ Active CTF participant',
    '   └─ Bug bounty hunter',
    '',
    '⚡ Current Focus:',
    '   └─ Advanced Persistent Threat (APT) analysis',
    '   └─ Zero-day vulnerability research',
    '   └─ AI security and prompt injection techniques',
    ''
  ],
  'neofetch': [
    '                    ',
    '        .:---:.     deezsec@cyber-terminal',
    '       -///////-    ══════════════════════',
    '      -MMMMMMMMM-   OS: Arch Linux x86_64',
    '      -MMMMMMMMM-   Host: Yoga Slim 7 ProX 14IAH7',
    '      -MMMMMMMMM-   Kernel: 6.6.9-arch1-1',
    '      -MMMMMMMMM-   Uptime: 2 hours, 14 mins',
    '      -MMMMMMMMM-   Packages: 1337 (pacman)',
    '       .:::::::.    Shell: zsh 5.9',
    '      -MMMMMMMMM-   Resolution: 1920x1080',
    '      -MMMMMMMMM-   DE: Plasma 5.27.10',
    '      -MMMMMMMMM-   WM: KWin',
    '      -MMMMMMMMM-   Theme: Cyberpunk Neon',
    '      -MMMMMMMMM-   Icons: Papirus-Dark',
    '       -///////-    Terminal: This awesome CyberTerminal!',
    '        -:::::-     CPU: 12th Gen Intel i7-12700H (20) @ 4.600GHz',
    '                    GPU: NVIDIA GeForce RTX 3050 Mobile',
    '                    Memory: Enhanced with Anime.js animations',
    '                    ',
    '                    Colors:',
    '                    ████████ ████████ ████████ ████████',
    ''
  ],
  'socials': [
    '╔════════════════════════════════════════════════════════════╗',
    '║                  SOCIAL CONNECTIONS                        ║',
    '╚════════════════════════════════════════════════════════════╝',
    '',
    '🔗 Professional Networks:',
    '   ├─ LinkedIn: https://www.linkedin.com/in/deezsec',
    '   ├─ GitHub: https://github.com/deezsec',
    '   └─ Twitter/X: https://twitter.com/deezsec',
    '',
    '🏆 Security Platforms:',
    '   ├─ HackTheBox: [Profile Link]',
    '   ├─ TryHackMe: [Profile Link]',
    '   └─ BugCrowd: [Profile Link]',
    '',
    '📝 Content & Blogs:',
    '   ├─ Medium: Security writeups & tutorials',
    '   ├─ Dev.to: Technical deep dives',
    '   └─ Personal Blog: Coming soon...',
    '',
    '💡 Let\'s connect and collaborate on security research!',
    ''
  ],
  'matrix': [
    '🔮 Matrix mode toggled!',
    '   Reality is now optional...',
    ''
  ],
  'easteregg': [
    '🎉 Congratulations! You found the easter egg!',
    '   "The best way to predict the future is to invent it."',
    '   - Alan Kay',
    '',
    '🎁 Hidden achievement unlocked: Curious Explorer',
    ''
  ],
  'hack': [
    '⚠️  UNAUTHORIZED ACCESS ATTEMPT DETECTED',
    '   [###########---------] 60% Complete',
    '   ERROR: Firewall engaged',
    '   Nice try though! 😄',
    ''
  ],
  'sudo': [
    '🔐 sudo: Access denied',
    '   You need more than sudo privileges for this terminal.',
    '   Try being nicer to the AI overlords. 🤖',
    ''
  ]
};
